import Header from "../components/Header";
import Footer from "../components/Footer";
import Map from "../components/Map";

function Login(){
    return(
        <>
        <Header />
        <Map />

        <Footer />
        </>
);
}

export default Login;